import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './badge.css?inline';

const CName = 'incentive-badge';
export type BadgeVariants = 'default' | 'secondary' | 'semi-transparent' | 'semi-transparent-dynamic' | 'live';
export type BadgeSizes = 'xs' | 'md';

@customElement(CName)
export class IncentiveBadge extends LitElement {
  static readonly styles = unsafeCSS(styles);
  @property({ type: String }) label = '';
  @property({ type: String }) variant: BadgeVariants = 'default';
  @property({ type: String }) size: BadgeSizes = 'xs';

  render() {
    const badgeClasses = classMap({
      badge: true,
      'badge--default': this.variant === 'default',
      'badge--secondary': this.variant === 'secondary',
      'badge--semi-transparent': this.variant === 'semi-transparent',
      'badge--semi-transparent-dynamic': this.variant === 'semi-transparent-dynamic',
      'badge--live': this.variant === 'live',
      'badge--xs': this.size === 'xs',
      'badge--md': this.size === 'md',
    });

    return html`
      <div class=${badgeClasses}>
        ${this.label ? html`<span class="badge__label">${this.label}</span>` : nothing}
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: IncentiveBadge;
  }
}
